import { Box, Stack } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'
import { Sidebar } from '@/components/Sidebar'
import { styles } from './styles'
import { Header } from './modules/Header'
import { ChangeOrganization } from '@/components'

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box sx={styles.layout}>
      <Box sx={styles.sidebar}>
        <Sidebar />
      </Box>
      <Box sx={styles.section}>
        <Stack>
          <Box sx={styles.header}>
            <Header />
          </Box>
          {children}
        </Stack>
      </Box>
      <ChangeOrganization />
    </Box>
  )
}
